<div class="routine-item-edit shadow-l rounded-2 mb-3 d-flex">
    <div class="align-self-center" style="min-width: 40px">
        <% if ( icon ) {  %>
            <img src="/assets/icons/routines/<%= icon %>"
                 style="max-width: 18px; margin-left: 11px; margin-bottom: 4px;" />
        <% }  %>
    </div>
    <div class="align-self-center routine-name">
        <%= name %>
    </div>
    <div class="ms-auto ps-3 align-self-center text-center clickable"
         data-type="<%= true === isStatic ? 'btnDelete' : 'btnEdit' %>"
         style="min-width: 50px!important;">
        <% if ( true === isStatic ) {   %>
            <i class="far fa-trash-alt"></i>
        <% } else {     %>
            <i class="far fa-edit"></i>
        <% }    %>
    </div>
</div>
